require('./lib/input')